import {
  KoForm,
  KoFormBuilder,
  KoInput,
  KoSelect
} from 'packages';
import {
  PROTOCOL_OPTIONS,
  VERSION_STRATEGY_OPTIONS,
  SERVICE_STATUS_OPTIONS,
  AUTH_TYPE_OPTIONS
} from '../../constants';

function ServiceCrud({ form, handleFinish }) {
  const ProtocolWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select protocol' options={PROTOCOL_OPTIONS} />
  );

  const VersionStrategyWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Version strategy' options={VERSION_STRATEGY_OPTIONS} />
  );

  const StatusWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select status' options={SERVICE_STATUS_OPTIONS} />
  );

  const AuthWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Auth type' options={AUTH_TYPE_OPTIONS} />
  );

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields: [
      { key: 'name', label: 'Service Name', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: 'e.g. User Service' } },
      { key: 'baseUrl', label: 'Base URL', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: 'https://api.example.com/v1' } },
      { key: 'protocol', label: 'Protocol', colSpan: 1, widget: ProtocolWidget, forwardRef: true, required: true },
      { key: 'version', label: 'Version', colSpan: 1, widget: KoInput, widgetProps: { placeholder: 'v1.0.0' } },
      { key: 'versionStrategy', label: 'Version Strategy', colSpan: 1, widget: VersionStrategyWidget, forwardRef: true },
      { key: 'status', label: 'Status', colSpan: 1, widget: StatusWidget, forwardRef: true },
      { key: 'owner', label: 'Owner', colSpan: 2, widget: KoInput, widgetProps: { placeholder: 'Team or person' } },
      { key: 'authType', label: 'Auth Type', colSpan: 2, widget: AuthWidget, forwardRef: true },
      { key: 'tags', label: 'Tags', colSpan: 2, widget: KoInput, widgetProps: { placeholder: 'Comma-separated tags' } },
      { key: 'description', label: 'Description', colSpan: 4, widget: KoInput.TextArea, widgetProps: { rows: 3, placeholder: 'Service description...' } }
    ]
  };

  return (
    <KoForm form={form} layout='vertical' onFinish={handleFinish}>
      <KoFormBuilder form={form} meta={meta} />
    </KoForm>
  );
}

export default ServiceCrud;
